import React, { useState } from 'react';

function Login({ onLoginSuccess }) {
  const [isLoginMode, setIsLoginMode] = useState(true); // true = Sign In, false = Register
  
  // Form states
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg('');

    const existingUsers = JSON.parse(localStorage.getItem('vyodha_users') || '[]');

    if (isLoginMode) {
      // Login Mode Verification
      if (!email || !password) {
        setErrorMsg("Kripya Email aur Password dono bharein.");
        return;
      }

      const validUser = existingUsers.find(
        u => u.email.toLowerCase() === email.trim().toLowerCase() && u.password === password.trim()
      );

      if (validUser || (email === 'admin@vyodha.com' && password === 'admin')) {
        const currentUser = validUser || { name: 'Admin Trader', email, mobile: '9999999999', myReferralCode: 'VYODHA-ADMIN', points: 1000 };
        localStorage.setItem('vyodha_current_user', JSON.stringify(currentUser));
        alert("Login successful! Welcome back, Trader.");
        onLoginSuccess();
      } else {
        setErrorMsg("❌ User ID ya Password galat hai! Kripya sahi credentials dalein.");
      }

    } else {
      // Registration Mode
      if (!name || !email || !mobile || !password || !confirmPassword) {
        setErrorMsg("Kripya sabhi required fields bharein.");
        return;
      }
      if (password !== confirmPassword) {
        setErrorMsg("Passwords match nahi ho rahe hain!");
        return;
      }

      const userExists = existingUsers.find(u => u.email.toLowerCase() === email.toLowerCase());
      if (userExists) {
        setErrorMsg("Yeh email pehle se registered hai. Kripya Login karein.");
        return;
      }

      let appliedDiscount = false;
      if (referralCode.trim()) {
        const referrer = existingUsers.find(u => u.myReferralCode === referralCode.trim());
        if (referrer) {
          referrer.points = (referrer.points || 0) + 100; // Referrer gets 100 points
          appliedDiscount = true;
          localStorage.setItem('vyodha_users', JSON.stringify(existingUsers));
        }
      }

      const newUser = {
        name: name.trim(),
        email: email.trim(),
        mobile: mobile.trim(),
        password: password.trim(),
        myReferralCode: `VYODHA-${Math.floor(1000 + Math.random() * 9000)}`,
        points: 0,
        hasDiscount: appliedDiscount,
        trialEndDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(),
        subscriptionPlan: 'Free Trial (14 Days)'
      };

      existingUsers.push(newUser);
      localStorage.setItem('vyodha_users', JSON.stringify(existingUsers));
      localStorage.setItem('vyodha_current_user', JSON.stringify(newUser));

      if (appliedDiscount) {
        alert(`🎉 Registration successful with Referral Code: ${referralCode}! 20% discount unlocked.`);
      } else {
        alert("Registration successful! Welcome to Vyodha. 14-day trial activated.");
      }
      
      onLoginSuccess();
    }
  };

  return (
    <div style={{ 
      background: 'radial-gradient(circle at center, #1E293B 0%, #0B0F19 100%)', 
      color: '#F3F4F6', 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      
      {/* Background Glowing Ambient Orbs */}
      <div style={{
        position: 'absolute', top: '-10%', left: '-10%', width: '400px', height: '400px',
        background: 'rgba(212, 175, 55, 0.08)', borderRadius: '50%', filter: 'blur(90px)', zIndex: 1
      }}></div>
      <div style={{
        position: 'absolute', bottom: '-10%', right: '-10%', width: '400px', height: '400px',
        background: 'rgba(0, 200, 83, 0.06)', borderRadius: '50%', filter: 'blur(90px)', zIndex: 1
      }}></div>

      {/* Main Container Card */}
      <div style={{ 
        display: 'flex',
        width: '100%',
        maxWidth: '960px',
        backgroundColor: 'rgba(15, 23, 42, 0.75)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '24px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
        zIndex: 2,
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}>
        
        {/* Left Brand Panel (Desktop View) */}
        <div style={{ 
          flex: 1, 
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, rgba(15, 23, 42, 0.9) 100%)',
          padding: '50px 40px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          borderRight: '1px solid rgba(255, 255, 255, 0.08)',
          boxSizing: 'border-box'
        }}>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/logo1.png" alt="Logo" style={{ height: '70px', width: 'auto', objectFit: 'contain' }} />
            </div>

          <div style={{ margin: '40px 0' }}>
            <span style={{ backgroundColor: 'rgba(212, 175, 55, 0.15)', color: '#D4AF37', padding: '6px 14px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Institutional Workspace
            </span>
            <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '32px', fontWeight: '900', margin: '15px 0 10px 0', lineHeight: '1.2', color: '#FFFFFF' }}>
              Execution <br /><span style={{ color: '#D4AF37' }}>Without Limits.</span>
            </h2>
            <p style={{ color: '#9CA3AF', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>
              Access elite AI vision analysis, zero-lag multi-broker routing, and automated trailing risk protection in one unified terminal.
            </p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#6EE7B7', fontSize: '13px', fontWeight: '600' }}>
            <span style={{ width: '8px', height: '8px', backgroundColor: '#00C853', borderRadius: '50%', boxShadow: '0 0 10px #00C853' }}></span>
            Multiverse Terminal Node Online 🟢
          </div>

        </div>

        {/* Right Form Panel */}
        <div style={{ flex: 1, padding: '40px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'center', maxHeight: '85vh', overflowY: 'auto' }}>
          
          {/* Tab Switcher (Sign In / Create Account) */}
          <div style={{ display: 'flex', background: 'rgba(255, 255, 255, 0.05)', padding: '5px', borderRadius: '12px', marginBottom: '20px', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <button 
              type="button"
              onClick={() => { setIsLoginMode(true); setErrorMsg(''); }} 
              style={{ 
                flex: 1, padding: '11px', border: 'none', 
                background: isLoginMode ? '#D4AF37' : 'transparent', 
                color: isLoginMode ? '#000000' : '#9CA3AF', 
                fontWeight: '800', borderRadius: '8px', cursor: 'pointer', fontSize: '13px',
                boxShadow: isLoginMode ? '0 4px 15px rgba(212, 175, 55, 0.3)' : 'none'
              }}
            >
              Sign In
            </button>
            <button 
              type="button"
              onClick={() => { setIsLoginMode(false); setErrorMsg(''); }} 
              style={{ 
                flex: 1, padding: '11px', border: 'none', 
                background: !isLoginMode ? '#D4AF37' : 'transparent', 
                color: !isLoginMode ? '#000000' : '#9CA3AF', 
                fontWeight: '800', borderRadius: '8px', cursor: 'pointer', fontSize: '13px',
                boxShadow: !isLoginMode ? '0 4px 15px rgba(212, 175, 55, 0.3)' : 'none'
              }}
            >
              Create Account
            </button>
          </div>

          <h3 style={{ fontSize: '18px', fontFamily: "'Cinzel', serif", marginBottom: '15px', color: '#FFFFFF', fontWeight: '700' }}>
            {isLoginMode ? 'Welcome Back, Trader 🚀' : 'Join the Elite Ecosystem ✨'}
          </h3>

          {errorMsg && (
            <div style={{ backgroundColor: 'rgba(255, 23, 68, 0.15)', color: '#FF1744', padding: '10px', borderRadius: '8px', fontSize: '12px', marginBottom: '15px', textAlign: 'center', border: '1px solid rgba(255, 23, 68, 0.3)', fontWeight: 'bold' }}>
              {errorMsg}
            </div>
          )}
          
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            
            {!isLoginMode && (
              <div>
                <label style={{ fontSize: '12px', color: '#9CA3AF', display: 'block', marginBottom: '4px', fontWeight: '600' }}>Full Name</label>
                <input 
                  type="text" 
                  placeholder="Aarav Sharma" 
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={{ width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', color: '#FFFFFF', padding: '10px 14px', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', fontSize: '13px' }}
                />
              </div>
            )}

            <div>
              <label style={{ fontSize: '12px', color: '#9CA3AF', display: 'block', marginBottom: '4px', fontWeight: '600' }}>Email ID</label>
              <input 
                type="email" 
                placeholder="trader@vyodha.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', color: '#FFFFFF', padding: '10px 14px', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', fontSize: '13px' }}
              />
            </div>

            {!isLoginMode && (
              <div>
                <label style={{ fontSize: '12px', color: '#9CA3AF', display: 'block', marginBottom: '4px', fontWeight: '600' }}>Mobile Number</label>
                <input 
                  type="tel" 
                  placeholder="9876543210" 
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  style={{ width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', color: '#FFFFFF', padding: '10px 14px', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', fontSize: '13px' }}
                />
              </div>
            )}

            <div>
              <label style={{ fontSize: '12px', color: '#9CA3AF', display: 'block', marginBottom: '4px', fontWeight: '600' }}>Password</label>
              <input 
                type="password" 
                placeholder="••••••••" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', color: '#FFFFFF', padding: '10px 14px', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', fontSize: '13px' }}
              />
            </div>

            {!isLoginMode && (
              <>
                <div>
                  <label style={{ fontSize: '12px', color: '#9CA3AF', display: 'block', marginBottom: '4px', fontWeight: '600' }}>Confirm Password</label>
                  <input 
                    type="password" 
                    placeholder="••••••••" 
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{ width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', color: '#FFFFFF', padding: '10px 14px', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', fontSize: '13px' }}
                  />
                </div>

                <div>
                  <label style={{ fontSize: '12px', color: '#D4AF37', display: 'block', marginBottom: '4px', fontWeight: '600' }}>Referral Code <span style={{ color: '#6B7280', fontWeight: 'normal' }}>(Optional - 20% Off)</span></label>
                  <input 
                    type="text" 
                    placeholder="e.g. VYODHA-4821" 
                    value={referralCode}
                    onChange={(e) => setReferralCode(e.target.value)}
                    style={{ width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(212, 175, 55, 0.4)', color: '#FFFFFF', padding: '10px 14px', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', fontSize: '13px' }}
                  />
                </div>
              </>
            )}

            <button type="submit" style={{ 
              backgroundColor: '#D4AF37', color: '#000', border: 'none', padding: '12px', borderRadius: '8px', 
              fontWeight: '800', cursor: 'pointer', marginTop: '8px', fontSize: '14px', 
              boxShadow: '0 4px 20px rgba(212, 175, 55, 0.4)'
            }}>
              {isLoginMode ? 'Sign In to Terminal' : 'Complete Registration'}
            </button>
          </form>

        </div>

      </div>
    </div>
  );
}

export default Login;